export default {
  module: {
    key: 'bbs/anonymous',
    id: 'bbs-anonymous',
  },
  setting: {},
};
